import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CustomerGroupProvider extends HttpRequest {
  findAll () {
    return this.get('/ticket')
  }

  findAllTicket (page = 1, limit = 50) {
    return this.get(`/ticket/dashboard/all?page=${page}&limit=${limit}`)
  }

  findAllStatus (userId, config) {
    return this.get(`/ticket/status/all?userId=${userId}`, undefined, config)
  }

  findOne (id, config) {
    return this.get(`/ticket/${id}`, undefined, config)
  }

  findByCode (code) {
    return this.get(`/ticket/${code}/code`)
  }

  findByCustomerProfile (id, page = 1, limit = 10, query) {
    return this.get(`/ticket/customer-profile/${id}?page=${page}&limit=${limit}${generateQuery(query)}`)
  }

  createGroup (payload) {
    return this.post('/ticket', payload)
  }

  createInitial (userId) {
    return this.post(`/ticket/initial?userId=${userId}`)
  }

  createTicketByCustomer (customerId, userId) {
    return this.post(`/ticket/${customerId}/customer?userId=${userId}`)
  }

  duplicateTicket (payload) {
    return this.post('/ticket/duplicate', payload)
  }

  reOpenTicket (id, payload) {
    return this.post(`/ticket/${id}/re-open`, payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/ticket/${id}`, payload)
  }

  voidTicket (id) {
    return this.post(`/ticket/${id}/void`)
  }

  deleteGroup (id) {
    return this.delete(`/ticket/${id}`)
  }

  paginate (page = 1, limit = 10, query, config) {
    return this.get(`/ticket?page=${page}&limit=${limit}`, query, config)
  }

  transferTicket (ticketId, agentId) {
    return this.post(`/ticket/${ticketId}/transfer`, {
      agentId
    })
  }

  /**
   * Business-hours due date preview (same math as ticket save SLA).
   * @param {{ groupId: number|string, categoryId: number|string, ticketId?: number|string, openDate?: string }} query
   */
  calculateSla (query, config) {
    return this.get('/ticket/calculate/sla', query, config)
  }
}

export default CustomerGroupProvider
